import React from "react";
import { ComponentInfoProps } from "../../../../../../common/types/componentInfo.types";

import { useSingleTransaction } from "../../../../hooks/useTransaction";
import { Transaction } from "../../../../types/transaction.types";
import { dateConverter } from "../../../../../../utils/dateConverter";
import { numberFormaterString } from "../../../../../../utils/numberFormater";
import { limitString } from "../../../../../../utils/string.utils";

export default function SingleTransactionInfo({
  info,
  id,
  emptyText,
  limitText,
  renderComponent,
}: ComponentInfoProps<Transaction>) {
  const {
    singleTransactionQuery: { isError, isLoading, data },
  } = useSingleTransaction(id);

  if (isLoading) return <>...</>;
  if (isError) return <>{emptyText ? emptyText : ""}</>;
  
  const translateInfo = (valueKey: keyof Transaction, valueRaw: any) => {
    if (!valueKey) return "";
    switch (valueKey) {
      case "w_transaction_created_at":
        return dateConverter(valueRaw as any);
      case "w_transaction_updated_at":
        return dateConverter(valueRaw as any);
      case "w_transaction_amount":
        return numberFormaterString(valueRaw as any);
      default:
        return valueRaw;
    }
  };

  if (renderComponent) {
    return (
      <>
        {renderComponent({
          value: data?.[info],
          labelRender: <span>{info}</span>,
          goTo: () => null,
        })}
      </>
    );
  }

  const value = translateInfo(info, data?.[info]);

  return <> {value ? limitString(value, limitText) : emptyText} </>;
}
